import { Column } from 'react-table'

export const FeedbackColumns: Column[] = [
  {
    Header: 'Level',
    accessor: 'level',
  },
  {
    Header: 'Class ID',
    accessor: 'class_id',
  },
  {
    Header: 'Assigned Teacher',
    accessor: 'assigned_teacher',
  },
  {
    Header: 'Day',
    accessor: 'day',
  },
  {
    Header: 'Date',
    accessor: 'date',
  },
  {
    Header: 'Timeslot',
    accessor: 'timeslot',
  },
  
  {
    Header: 'Progress',
    accessor: 'progress',
  },
]
